import { Component, Input } from '@angular/core';
import { RouteURLConstants} from '../../../constants/upplm.constants';
import { Router } from '@angular/router';

@Component({
    selector: 'placardAddClientKeyConfirm',
    template: require('./placardAddClientKeyConfirm.component.html')
})
export class PlacardAddClientKeyConfirmComponent {
    @Input() public placardId: string = ''; 
    constructor(private router: Router) { }

    public gotoDashboard() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
    }
}